module.exports = __webpack_public_path__ + "media/images/faces/profile/profile-c5e612f19b71952b1ecfe63553d74df4.jpg";